import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';

import clsx from 'clsx';

import { AppDispatch } from '../../../redux/reducer/store';
import {
  actionGetVacancies,
  //actionVacanciesFilters,
} from '../../../redux/action/recruiting/actionVacancy';
import {
  reducerSelectedVacanciesId,
  reducerVacancyStatus,
  reducerVacancyListInputValues,
  reducerVacancyMultiselect,
  reducerGetProject,
  reducerGetVacancyList
} from '../../../redux/reducer/recruiting/reducers/reducerVacancy';
import { reducerSelectedEmployeesId } from '../../../redux/reducer/employees/reducers/employeesList';
import { generateStyles } from '../../../utils/generateToastStyles';

import { formatDateWithDots } from '../../../utils/formatDate';
import { formatReports } from '../../../utils/formatReports';

import Loader from '../../custom/loader/loader';
import CustomMultiSelect from '../../custom/customMultiSelect/customMultiSelect';
import Select from '../../custom/select/select';
import RangeDatePicker from '../../custom/rangeDatePicker/rangeDatePicker';
import Pagination from '../../pagination/pagination';
import LimitSelect from '../../custom/limitSelect/limitSelect';
import ToastPopup from '../../custom/toastPopup/toastPopup';

import '../table.scss';
import styles from './employees.module.scss';
import { IUserOptions } from '../../../types/interfaces';

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const booleanOptions = [
  { value: 'all', label: 'Все' },
  { value: 'yes', label: 'Да' },
  { value: 'no', label: 'Нет' },
];

const verifiedOptions = [
  { value: 'all', label: 'Все' },
  { value: 'yes', label: 'Да' },
  { value: 'no', label: 'Нет' },
  { value: 'waiting', label: 'Ожидает' },
];

const exampleEmployee = [{
  id: 1,
  name: 'Иванов Виктор Петрович',
  login: '',
  role: '',
  position: '',
  route: [2],
  freelancer: false,
  project: '',
  areas: 'Московская',
  service: '',
  vsv: '',
  phone: '999 888 77 66',
  registrationDate: '2024-03-19T18:02:41.244546',
  startDate: '2024-03-19T18:02:41.244546',
  createDate: '2024-03-19T18:02:41.244546',
  verified: true,
}];

const TableFiredEmployees: FC = () => {
  const dispatch: any = useDispatch<AppDispatch>();
  const { id } = useParams<{ id: string }>();

  const { firedListSettings } = useSelector((state: any) => state.employees.firedEmployeesList);

  const {
    data,
    limit,
    page,
    count,
    selectedVacanciesId,
    clientsStatus,
    clientsStatusMessage,
    vacancyListInputValues,
    modifiedDate,
    filters,
  } =
    useSelector((state: any) => state.recruiting.vacancyList);
  const { checkboxes } = useSelector((state: any) => state.employees.employeesList);
  const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);
  const requestStatusOptions = [
    {
      status: 400,
      errorMessage: clientsStatusMessage,
    },
    {
      status: 200,
      successMessage: 'Сотрудник создан!',
    },
    {
      status: 500,
      errorMessage: 'Ошибка на стороне сервера',
    }
  ];
  const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] =
    useState<boolean>(false);
  const [isCheckedRows, setIsCheckedRows] = useState<boolean[]>(checkboxes);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startPage, setStartPage] = useState<number>(1);
  const [isInputChange, setIsInputChange] = useState<boolean>(false);
  const [isPending, setIsPending] = useState<boolean>(false);

  const actualLimit =
    JSON.parse(localStorage.getItem('pageLimit') as string) || limit;
  const detectedBasename = window.location.pathname.startsWith('/react')
    ? '/react'
    : '';
  useEffect(() => {
    if (selectedVacanciesId && !selectedVacanciesId.length) {
      setIsCheckedRows(data && checkboxes);
      setIsHeaderCheckboxChecked(false);
    }
  }, [checkboxes, data, selectedVacanciesId]);

  useEffect(() => {
    if (data) {
      const updatedCheckedRows =
        data &&
        data.reduce((acc: any, vacancy: any) => {
          const vacancyId = vacancy.vacancy.value?.id;
          acc[vacancyId] = false;
          return acc;
        }, {});
      dispatch(reducerSelectedVacanciesId(formatReports(updatedCheckedRows)));
      setIsCheckedRows(updatedCheckedRows);
    }
  }, [dispatch, data]);

  const handleHeaderCheckboxChange = () => {
    setIsHeaderCheckboxChecked(!isHeaderCheckboxChecked);
  };
  const handleRowCheckboxChange = (id: number) => {
    const employeeId = id;
    setIsCheckedRows((prevCheckedRows: boolean[]) => ({
      ...prevCheckedRows,
      [employeeId]: !prevCheckedRows[employeeId],
    }));
    const updatedSelectedEmployees = formatReports({
      ...isCheckedRows,
      [employeeId]: !isCheckedRows[employeeId],
    });
    dispatch(reducerSelectedEmployeesId(updatedSelectedEmployees));
    if (updatedSelectedEmployees.length === exampleEmployee.length) {
      setIsHeaderCheckboxChecked(true);
    } else {
      setIsHeaderCheckboxChecked(false);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (value === '') {
      const updatedInputValues = { ...vacancyListInputValues };
      if (name === 'id') {
        delete updatedInputValues.vacancy;
      } else {
        delete updatedInputValues[name];
      }
      dispatch(reducerVacancyListInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacancyListInputValues({
          ...vacancyListInputValues,
          ...(name === 'routes' ? { [name]: [value] } : name === 'id' ? { vacancy: [{ id: value }] } : { [name]: value })
        })
      );
    }
    setIsInputChange(true);
  };
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setIsInputChange(false);
      resetPages();
    }
  };
  const selectChange = (event: { value: string, label: string }, name: string) => {
    if (event.value === '') {
      const updatedInputValues = { ...vacancyListInputValues };
      delete updatedInputValues[name];
      dispatch(reducerVacancyListInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacancyListInputValues({
          ...vacancyListInputValues,
          [name]: event.value === 'all' ? null : event.value === 'yes',
        })
      )
      setIsInputChange(true);
    }
  };
  const handleChange = (newLimit: number, newPage: number) => {
    localStorage.setItem('pageLimit', JSON.stringify(newLimit));
  };

  const resetPages = () => {
    setCurrentPage(1);
    setStartPage(1);
  };
  const handleChangeLimits = (option: { value: number }) => {
    handleChange(option.value, 1);
    resetPages();
  };

  useEffect(() => {
    requestStatusOptions.forEach((option: any) => {
      if (clientsStatus === option.status) {
        toast.dismiss();
        toast(
          t => (
            <ToastPopup
              title={
                option.successMessage
                  ? option.successMessage
                  : option.errorMessage
              }
              isSuccess={option.successMessage ? true : false}
              toast={toast}
              t={t}
            />
          ),
          generateStyles(option.successMessage ? true : false)
        );
      }
    });
    setTimeout(() => {
      dispatch(reducerVacancyStatus(null));
    }, 5000);
    // eslint-disable-next-line
  }, [dispatch, clientsStatus]);

  useEffect(() => {
    const handleDocumentClick = (event: any) => {
      const touchedInputs = ['salary', 'revenue'];
      if (!touchedInputs.includes(event.target.name) && isInputChange) {
        setIsInputChange(false);
        resetPages();
      }
    };
    if (isInputChange) {
      document.addEventListener('click', handleDocumentClick);
      return () => {
        document.removeEventListener('click', handleDocumentClick);
      };
    } else
      return () => {
        document.removeEventListener('click', handleDocumentClick);
      };
  }, [dispatch, isInputChange, limit, page]);
  useEffect(() => {
    //dispatch(actionVacanciesFilters())
  }, [dispatch]);

  useEffect(() => {
    dispatch(reducerGetProject(id ? [{ id: id }] : null));
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(reducerGetVacancyList({ data: [] }))
  }, [dispatch]);

  return (
    <>
      <div className='loader__wrapper'>
        {(isPending) && <Loader />}
      </div>

      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
          isOpenSidebar &&
          'active__table',
          !isOpenSidebar && 'closed__table',
          'table'
        )}
      >
        {(clientsStatus && clientsStatus !== null) && <Toaster
          position='top-center'
          toastOptions={{
            duration: 5000,
          }}
        />}
        <div className='table__wrapper'>
          <table>
            <thead className='table__header'>
              <tr>
                <th className='reports__checkbox_block'>
                  {(claims.includes('admin') || claims.includes('recruiting:vacancy:export') || claims.includes('recruiting:vacancy:edit')) &&
                    <input
                      onChange={handleHeaderCheckboxChange}
                      type='checkbox'
                    />}
                </th>

                {firedListSettings.includes('name') && <th style={{ minWidth: '280px' }}>
                  <div className='filter__block'>
                    <input
                      onChange={handleInputChange}
                      onKeyPress={handleKeyPress}
                      autoComplete='off'
                      placeholder=' '
                      name='name'
                      type='text'
                    />
                    <label>ФИО</label>
                  </div>
                </th>}

                {firedListSettings.includes('login') && <th style={{ minWidth: '280px' }}>
                  <div className='filter__block'>
                    <input
                      onChange={handleInputChange}
                      onKeyPress={handleKeyPress}
                      autoComplete='off'
                      placeholder=' '
                      name='login'
                      type='text'
                    />
                    <label>Логин</label>
                  </div>
                </th>}

                {firedListSettings.includes('role') && <th>
                  <div className='multiselect__filter_block'>
                    <CustomMultiSelect
                      setLoading={setIsPending}
                      inputValues={[]}
                      options={filters.types}
                      isShowPlaceholder={true}
                      pageName='userReports'
                      placeholder='Роль'
                      name='role'
                      limit={limit}
                      reducer={reducerVacancyMultiselect}
                      resetPages={() => { }}
                      action={actionGetVacancies}
                    />
                  </div>
                </th>}

                {firedListSettings.includes('position') && <th>
                  <div className='multiselect__filter_block'>
                    <CustomMultiSelect
                      setLoading={setIsPending}
                      inputValues={[]}
                      options={filters.types}
                      isShowPlaceholder={true}
                      pageName='userReports'
                      placeholder='Должность'
                      name='position'
                      limit={limit}
                      reducer={reducerVacancyMultiselect}
                      resetPages={() => { }}
                      action={actionGetVacancies}
                    />
                  </div>
                </th>}

                {firedListSettings.includes('project') && <th>
                  <div className='multiselect__filter_block'>
                    <CustomMultiSelect
                      setLoading={setIsPending}
                      inputValues={[]}
                      options={filters.types}
                      isShowPlaceholder={true}
                      pageName='userReports'
                      placeholder='Проект'
                      name='project'
                      limit={limit}
                      reducer={reducerVacancyMultiselect}
                      resetPages={() => { }}
                      action={actionGetVacancies}
                    />
                  </div>
                </th>}

                {firedListSettings.includes('areas') && <th>
                  <div
                    className={clsx('filter__number_block', styles.checkin)}
                  >
                    <Select
                      options={[]}
                      propsChange={(event: { value: string, label: string }) =>
                        selectChange(event, "areas")
                      }
                      placeholder='Область'
                      className='users__filter'
                      name='areas'
                    />
                  </div>
                </th>}

                {firedListSettings.includes('vsv') && <th>
                  <div className='multiselect__filter_block'>
                    <CustomMultiSelect
                      setLoading={setIsPending}
                      inputValues={[]}
                      options={filters.virtualSupervisors}
                      isShowPlaceholder={true}
                      pageName='userReports'
                      placeholder='ВСВ'
                      name='vsv'
                      limit={limit}
                      resetPages={() => { }}
                      reducer={reducerVacancyMultiselect}
                      action={actionGetVacancies}
                    />
                  </div>
                </th>}

                {firedListSettings.includes('freelancer') && <th>
                  <div
                    className={clsx('filter__number_block', styles.checkin)}
                    style={{ minWidth: "105px" }}
                  >
                    <Select
                      options={booleanOptions}
                      propsChange={(event: { value: string, label: string }) =>
                        selectChange(event, "hasUrl")
                      }
                      placeholder='Фрилансер'
                      className='users__filter'
                      name="freelancer"
                    />
                  </div>
                </th>}

                {firedListSettings.includes('firedData') && <th style={{ minWidth: '140px' }}>
                  <RangeDatePicker
                    setLoading={setIsPending}
                    reducer={reducerVacancyListInputValues}
                    defaultDateFrom={modifiedDate.formattedDateFrom}
                    inputValues={vacancyListInputValues}
                    defaultDateTo={modifiedDate.formattedDateTo}
                    setCurrentPage={setCurrentPage}
                    action={() => { }}
                    setStartPage={setStartPage}
                    limit={limit}
                    page={page}
                    placeholder='Дата увольнения'
                    pageName='staffList'
                    name='firedData'
                  />
                </th>}

                {firedListSettings.includes('firedreason') && <th>
                  <div
                    className={clsx('filter__number_block', styles.checkin)}
                    style={{ minWidth: "105px" }}
                  >
                    <Select
                      options={booleanOptions}
                      propsChange={(event: { value: string, label: string }) =>
                        selectChange(event, "firedreason")
                      }
                      placeholder='Причина увольнения'
                      className='users__filter'
                      name="firedreason"
                    />
                  </div>
                </th>}

                {firedListSettings.includes('comment') && <th style={{ minWidth: '180px' }}>
                  <div className='filter__block'>
                    <input
                      onChange={handleInputChange}
                      onKeyPress={handleKeyPress}
                      autoComplete='off'
                      placeholder=' '
                      name='comment'
                      type='text'
                    />
                    <label>Комментарий</label>
                  </div>
                </th>}

                {firedListSettings.includes('whoFired') && <th>
                  <div
                    className={clsx('filter__number_block', styles.checkin)}
                    style={{ minWidth: "105px" }}
                  >
                    <Select
                      options={[]}
                      propsChange={(event: { value: string, label: string }) =>
                        selectChange(event, "whoFired")
                      }
                      placeholder='Кто уволил'
                      className='users__filter'
                      name='whoFired'
                    />
                  </div>
                </th>}

                {firedListSettings.includes('phone') && <th style={{ minWidth: '180px' }}>
                  <div className='filter__block'>
                    <input
                      onChange={handleInputChange}
                      onKeyPress={handleKeyPress}
                      autoComplete='off'
                      placeholder=' '
                      name='phone'
                      type='text'
                    />
                    <label>Телефон</label>
                  </div>
                </th>}

                {firedListSettings.includes('verified') && <th>
                  <div
                    className={clsx('filter__number_block', styles.checkin)}
                  >
                    <Select
                      options={verifiedOptions}
                      propsChange={(event: { value: string, label: string }) =>
                        selectChange(event, "verified")
                      }
                      placeholder='Верифицирован'
                      className='users__filter'
                      name='verified'
                    />
                  </div>
                </th>}
              </tr>
            </thead>

            <tbody>
              {exampleEmployee.map((el: any, index: number) => {
                return (
                  <tr className='active__link_tr' key={index}>
                    <td>
                      {(claims.includes('admin') || claims.includes('recruiting:vacancy:export') || claims.includes('recruiting:vacancy:edit')) &&
                        <input
                          onChange={() => handleRowCheckboxChange(el.id)}
                          checked={(isCheckedRows && isCheckedRows[el.id]) || false
                          }
                          className='relative__elem'
                          type='checkbox'
                        />}
                    </td>
                    {firedListSettings.includes('name') && <td>
                      <span className={styles.relative__elem}>
                        {el?.name}
                      </span>
                    </td>}

                    {firedListSettings.includes('login') && <td>
                      <span className={styles.relative__elem}>
                        {el?.login}
                      </span>
                    </td>}

                    {firedListSettings.includes('role') && <td>
                      <span className={styles.relative__elem}>
                        {el?.role}
                      </span>
                    </td>}

                    {firedListSettings.includes('position') && <td>
                      <span className={styles.relative__elem}>
                        {el?.position}
                      </span>
                    </td>}

                    {firedListSettings.includes('project') && <td>
                      <span className={styles.relative__elem}>
                        {el?.project}
                      </span>
                    </td>}

                    {firedListSettings.includes('areas') && <td>
                      <span className={styles.relative__elem}>
                        {el?.areas}
                      </span>
                    </td>}

                    {firedListSettings.includes('vsv') && <td>
                      <span className={styles.relative__elem}>
                        {el?.vsv}
                      </span>
                    </td>}

                    {firedListSettings.includes('freelancer') && <td>
                      <span className={styles.relative__elem}>
                        {el?.freelancer ? 'Да' : 'Нет'}
                      </span>
                    </td>}

                    {firedListSettings.includes('firedData') && <td>
                      <span className={styles.relative__elem}>
                        {formatDateWithDots(el?.startDate)}
                      </span>
                    </td>}

                    {firedListSettings.includes('firedreason') && <td>
                      <span className={styles.relative__elem}>
                        {el?.firedreason}
                      </span>
                    </td>}

                    {firedListSettings.includes('comment') && <td>
                      <span className={styles.relative__elem}>
                        {el?.comment}
                      </span>
                    </td>}

                    {firedListSettings.includes('whoFired') && <td>
                      <span className={styles.relative__elem}>
                        {el?.whoFired}
                      </span>
                    </td>}


                    {firedListSettings.includes('phone') && <td>
                      <span className={styles.relative__elem}>{el?.phone}</span>
                    </td>}

                    {firedListSettings.includes('verified') && <td>
                      <span className={styles.relative__elem}>
                        {el?.verified ? 'Да' : 'Нет'}
                      </span>
                    </td>}

                    <td className='invisible__reports_cell'>
                      <a
                        href={`${detectedBasename}/employees/profile/${el?.id}`}
                        className='link__tr'
                        draggable='false'
                        rel='noreferrer'
                        target='_blank'
                      >
                        {' '}
                      </a>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          {/*{((data && data !== null) && !data.length) && <div className='noData'>Нет данных</div>}*/}
        </div>

        <div className='pagination'>
          <div className='pagination__count'>Всего: {count}</div>
          <div className='pagination__str'>
            <span>Отображать строки</span>
            <LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
          </div>
          <Pagination
            setCurrentPage={setCurrentPage}
            setStartPage={setStartPage}
            handleChange={handleChange}
            count={count}
            currentPage={currentPage}
            startPage={startPage}
            limit={actualLimit}
            pageName='userReports'
          />
        </div>
      </div>
    </>
  );
};

export default TableFiredEmployees;